import { ApiResource } from '../api-resource';
import { MessageChannel } from '../message-channel/message-channel.model';
import { Endpoint } from '../api.decorators';
import { Field } from '../../util/components/resource/resource-fields';
import { Workshop } from '../workshop/workshop.model';
import { WorkshopTemplate } from '../workshop-template/workshop-template.model';

@Endpoint('workshop-themes', 'WorkshopTheme')
export class WorkshopTheme extends ApiResource<WorkshopTheme> {
  @Field({ label: $localize`Name` })
  name!: string;

  @Field({ label: $localize`Intro` })
  intro?: string | null;

  @Field({ label: $localize`Description` })
  description?: string | null;

  @Field({ label: $localize`Intro for organizations` })
  introForOrganization?: string | null;

  @Field({ label: $localize`Description for organizations` })
  descriptionForOrganization?: string | null;

  @Field({ label: $localize`Manuscript URL` })
  manuscriptUrl!: string;

  @Field({ label: $localize`Thumbnail URL`, type: () => Blob })
  thumbnail!: string | null;

  @Field({ type: () => Workshop, label: $localize`Workshops` })
  workshops?: Workshop[];

  @Field({ type: () => WorkshopTemplate, readonly: true, includeFilter: false })
  workshopTemplates?: WorkshopTemplate[];

  @Field({ includeFilter: false })
  channel?: MessageChannel;

  override toLabel(): string {
    return this.name;
  }

  // Virtual columns
  totalSeriesRegistrations!: number;
  totalWorkshopsRegistrations!: number;
}
